import FullWidthSection from '@/components/full-width-section';
import ImageOptimizer from '@/components/image-optimizer';
import { getDororoAppUrl } from '@/lib/utils';
import Link from 'next/link';

export default function CommonDororoBanner() {
  return (
    <FullWidthSection>
      {/** 웹 */}
      <div className="desktop:flex hidden flex-col items-center justify-center bg-[#0066F4]">
        <ImageOptimizer
          src="/images/recommend-class/common/dororo_banner.webp"
          alt="실시간 운전분석 데이터를 활용한 맞춤코칭&AI피드백 - 도로로 앱 배너"
          width={1180}
          height={318}
        />
      </div>
      {/** 모바일 */}
      <Link href={getDororoAppUrl()} target="_blank">
        <div className="desktop:hidden flex flex-col items-center justify-center bg-[#0066F4]">
          <ImageOptimizer
            src="/images/recommend-class/common/dororo_banner_mo.webp"
            alt="실시간 운전분석 데이터를 활용한 맞춤코칭&AI피드백 - 도로로 앱 배너"
            width={375}
            height={220}
          />
        </div>
      </Link>
    </FullWidthSection>
  );
}
